import { render, staticRenderFns } from "./SonrakiBar.vue?vue&type=template&id=36bdd4f2&"
import script from "./SonrakiBar.vue?vue&type=script&lang=js&"
export * from "./SonrakiBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports